import { PublicInstitutionsService } from '../../services/public-institutions.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PublicInstitution } from '../../models/PublicInstitution';
import { DataTableDirective } from 'angular-datatables';
import { InstitutionsService } from '../../shared/services/institutions.service';

@Component({
  selector: 'app-public-institutions-list',
  templateUrl: './public-institutions-list.component.html',
  styleUrls: ['./public-institutions-list.component.css']
})
export class PublicInstitutionsListComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  PublicInstitutions : PublicInstitution[] = [];
  listDetail: PublicInstitution;

  constructor(private _publicInstitutionsService: PublicInstitutionsService, private _institutions : InstitutionsService) { }

  ngOnInit() {
    this.dtOptions = this._publicInstitutionsService.getDataTableOptions(this.PublicInstitutions);
    this._institutions.UpdateInstitutions(this.PublicInstitutions);
  }


}
